import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { PaymentMethodsFacade, ShoppingCartFacade } from '@ridango/components';
import { savePaymentState } from '@ridango/components/lib/localStorage';
import { PaymentMethod, ShoppingCart } from '@ridango/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component( {
    selector: 'rwidget-cart-payment-methods',
    templateUrl: './cart-payment-methods.component.html'
} )
export class CartPaymentMethodsComponent implements OnInit {

    private componentDestroyed$ = new Subject<void>();

    cart$ = this.cartFacade.cart$;
    allDocNums$ = this.cartFacade.docNums$;

    allPaymentMethodsArray$ = this.paymentFacade.allPaymentMethods$;
    selectedPaymentMethod$ = this.paymentFacade.selectedPaymentMethod$;
    loading$ = this.paymentFacade.loading$;

    @ViewChild('methodsEl') methodsEl;

    methods: PaymentMethod[] = [];
    selectedMethod: PaymentMethod = null;
    cart: ShoppingCart = null;
    locale;

    constructor(
        private cartFacade: ShoppingCartFacade,
        private paymentFacade: PaymentMethodsFacade,
        @Inject( 'ENV' ) public env: any,
        private translate: TranslateService,
    ) { }

    ngOnInit() {
        this.locale = this.translate.currentLang;
        this.allDocNums$.pipe( takeUntil( this.componentDestroyed$ ) ).subscribe(
            docnums => {
                this.paymentFacade.setSelectedMethod( null );
                if ( docnums && docnums.length > 0 ) {
                    this.paymentFacade.fetchAllMethodsWithEpic(this.cart);
                }
            }
        );


        this.selectedPaymentMethod$.pipe( takeUntil( this.componentDestroyed$ ) ).subscribe( pm => {
            this.selectedMethod = pm;

        } );

        this.allPaymentMethodsArray$.pipe( takeUntil( this.componentDestroyed$ ) ).subscribe( m => {
            this.methods = m;
            if (this.methods.length === 1) {
                this.paymentFacade.setSelectedMethod(this.methods[0]);
            }
        });

        this.cart$.pipe( takeUntil( this.componentDestroyed$ ) ).subscribe( c => this.cart = c );


    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }


    methodSelected( pm: PaymentMethod ) {
        this.paymentFacade.setSelectedMethod( pm );
        savePaymentState(pm);
        this.selectedMethod = pm;

        // TODO: Wallet payment
        // this.cardService.setCardBalance( null );
        // if ( this.selectedMethod && this.selectedMethod.payment_type === 'W' && !this.selectedMethod.is_corporate && !this.selectedMethod.not_allowed_reason ) {
            // fetch balance (but where get the card id ??)
            // FIXME: using old elrons cart state, must change it to shopping cart service from components library
        //     const docnum = this.ngRedux.getState().cart.allDocNums[ 0 ];
        //     const cardNum = this.ngRedux.getState().cart.normTickets[ docnum ].visual_card_id;
        //     this.cardService.fetchCardBalance( cardNum ).subscribe(
        //         ( d: CardBalance ) => {
        //             d.balance = d.balance ? d.balance / 100 : 0;
        //             this.ls.log( this, 'this.cardService.fetchCardBalance d', d );
        //             this.cardService.setCardBalance( d );
        //         },
        //         e => {
        //             this.ls.log( this, 'this.cardService.fetchCardBalance e', e );
        //         },
        //         () => { }
        //     );
        // }
    }

    selectLeft( pm: PaymentMethod ) {
        this.setFocusToSibling( pm, -1 );
    }

    selectRight( pm: PaymentMethod ) {
        this.setFocusToSibling( pm, 1 );
    }

    setFocusToSibling( pm: PaymentMethod, direction: number ) {
        let destElId;

        this.methods.some( ( m, i ) => {
            if ( m.payment_id === pm.payment_id ) {
                destElId = i + direction;
                return true;
            }
        } );

        if ( destElId < 0 ) {
            destElId = this.methods.length - 1;
        } else if ( destElId >= this.methods.length ) {
            destElId = 0;
        }

        this.methodSelected( this.methods[ destElId ] );
        setTimeout( () => this.methodsEl.focusItems.toArray()[ destElId ].nativeElement.focus() );
    }

    focus( pm: PaymentMethod ) {
        this.methodsEl.focusItems.toArray()[ this.findElementIndex( pm ) ].nativeElement.classList.add( 'focus' );

        if ( this.selectedMethod ) {
            // If some item already selected, focusing on item selects
            this.methodSelected( pm );
        }
    }

    blur( pm: PaymentMethod ) {
        this.methodsEl.focusItems.toArray()[ this.findElementIndex( pm ) ].nativeElement.classList.remove( 'focus' );
    }

    findElementIndex( pm: PaymentMethod ) {
        return this.methods.findIndex(
            ( m: PaymentMethod ) => m.payment_id === pm.payment_id
        );
    }

    fetchMethods() {
        this.paymentFacade.fetchAllMethodsWithEpic(this.cart);
    }
}
